// extracted by mini-css-extract-plugin
module.exports = {"benefits":"careers_benefits__y8PD1","benefitColumn":"careers_benefitColumn__TjN1s","benefitHeader":"careers_benefitHeader__YCQHR","benefitImg":"careers_benefitImg__IHEGk"};